import carousel from '../modules/carousel';
import searchFilter from '../modules/search-filter';
export default {
    init() {},
    finalize() {
        carousel();
        searchFilter();
    },
};
